import { SECURITY_TYPES_TEXT } from '../../../../constants'
import { FlexRowBetween } from '../../update-balances/UpdateInvestmentListItemStyle'
import { InvestmentListItemBox } from '../../styled'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

const amountWrapsAtWidth = 990
const sidebarWidth = 0
const breakpoint = p =>
  p.sidebarOpen ? `${amountWrapsAtWidth}px` : `${amountWrapsAtWidth - sidebarWidth}px`

const Cell = styled.div`
  padding: 0 8px;
  word-wrap: break-word;
  white-space: pre-wrap;

  @media (max-width: ${breakpoint}) {
    width: 100%;
    flex-basis: auto;
  }
`

const Type = styled(Cell)`
  flex: 0 0 20%;
`

const Ticker = styled(Cell)`
  flex: 0 0 20%;
`

const Name = styled(Cell)`
  flex: 1 1 40%;
`

const Add = styled.div`
  color: ${p => p.theme.editColor};
  @media (max-width: ${breakpoint}) {
    padding: 0 8px;
  }
`

function AvailableInvestment(props) {
  const { investment, toggleAdd } = props

  return (
    <InvestmentListItemBox>
      <FlexRowBetween>
        <Type>{SECURITY_TYPES_TEXT[investment.securityType]}</Type>
        <Ticker>{investment.ticker}</Ticker>
        <Name>{investment.securityName}</Name>
        <Add sidebarOpen={false}>
          <a
            onClick={() => toggleAdd(investment.id)}
            css={css`
              cursor: pointer;
            `}>
            Add
          </a>
        </Add>
      </FlexRowBetween>
    </InvestmentListItemBox>
  )
}

export default AvailableInvestment
